import styled from 'styled-components';
import { Menu, Layout } from 'antd';
import { NavLink } from 'react-router-dom';
import SubMenu from 'antd/lib/menu/SubMenu';

const { Sider, Header, Content } = Layout;

export const StyledSider = styled(Sider)`
  overflow: auto;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 64px;
  z-index: 999999;
  background-color: ${(p) => p.theme.primaryColor};

  & .ant-layout-sider-trigger {
    background-color: rgb(56, 126, 245);
    width: 210px !important;
  }

  &.ant-layout-sider {
    flex: 0 0 210px !important;
    max-width: 210px !important;
    min-width: 210px !important;
    width: 210px !important;
  }

  &.ant-layout-sider-collapsed {
    &.ant-layout-sider {
      flex: 0 0 80px !important;
      max-width: 80px !important;
      min-width: 80px !important;
      width: 80px !important;
    }

    & .ant-layout-sider-trigger {
      width: 80px !important;
    }
  }

  @media print {    
    &.no-print, &.no-print * {
      display: none !important;
    }
  }
`;

export const StyledLogoContainer = styled.div`
  cursor: pointer;
  padding: 10px;
`;

export const StyleLogoImg = styled.img`
  max-width: 100px;
`;

export const StyleTitleContainer = styled.div`
  position: absolute;
  top: 38px;
  left: 65px;
  text-align: left;
`;

export const StyleHeaderTitle = styled.div`
  color: #ffffff;
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const StyleHeaderSubtitle = styled.div`
  color: #ffffff;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
`;

export const StyleHeaderLine = styled.div`
  color: #ffffff;
  font-size: 18px;
  line-height: 25px;
  text-transform: uppercase;
  padding-right: 10px;
`;

export const StyledLogo = styled.img`
  width: 100%;
`;

export const StyleUserContainer = styled.div`
  cursor: pointer;
  padding-right: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledHeader = styled(Header)`
  height: 64px;
  width: 100%;
  background-color: rgb(56, 126, 245);
  position: fixed;
  z-index: 999999;
  padding: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media print {    
    &.no-print, &.no-print * {
      display: none !important;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  background-color: #fff;
  width: 100%;
  height: calc(100% - 16px);
`;

export const StyledMenuDivider = styled(Menu.Divider)`
  background-color: #000;
  width: 100%;
  height: 5px;
  list-style-type: none;
`;

export const StyledMenuItem = styled(Menu.Item)`
  color: black;
  a {
    color: black;
  }
  &:hover {
    color: ${(p) => p.theme.primaryColor};
  }
`;

export const StyledSubMenu = styled(SubMenu)`
  color: black;
  a {
    color: black;
  }
  &:hover {
    color: ${(p) => p.theme.primaryColor};
  }
`;

export const MenuSVG = styled.i`
  width: ${({ size }) => size || '18px'};
  height: ${({ size }) => size || '18px'};
  display: inline-block;
  margin-right: 10px;

  svg {
    width: ${({ size }) => size || '18px'};
    height: ${({ size }) => size || '18px'};
  }
`;

export const StyledNavLink = styled(NavLink)`
  &.activated {
    color: ${(p) => p.theme.primaryColor};
    ${MenuSVG} {
      color: ${(p) => p.theme.primaryColor};
      fill: ${(p) => p.theme.primaryColor};
    }
  }

  &:hover {
    ${MenuSVG} {
      color: ${(p) => p.theme.primaryColor};
      fill: ${(p) => p.theme.primaryColor};
    }
  }
`;

export const MenuIcon = styled.img`
  width: 30px;
  height: 30px;
`;

export const StyledContent = styled(Content)`
  width: 100%;
  min-height: 100vh;
  padding-top: 64px;
  display: inline-block;
  background-color: ${(p) => p.theme.primaryBackgroundColor};
  text-align: center;

  @media print {
    padding-top: 0px !important;
  }
`;

export const HeaderTitle = styled.h1`
  height: 64px;
  line-height: 64px;
  font-size: 21px;
  font-weight: 350;
  text-transform: uppercase;
  color: white;
  margin-bottom: 0px;
`;

export const TransitionLayout = styled.div`
  width: 100%;
  display: inline-block;
  position: relative;
  padding-left: ${({ collapsed }) => (collapsed ? '80px' : '200px')};
  transition-delay: 0s;
  transition-duration: 0.2s;
  transition-property: padding-left;
  transition-timing-function: ease;

  @media print {
    padding-left: 0px !important;
  }
`;

export const HeaderSectionTitle = styled.div`
  color: white;
  display: inline-block;
  width: 100%;
  padding-right: 300px;
  position: relative;
  font-size: 22px;
`;

export const HeaderSectionToggle = styled.div`
  position: absolute;
  top: 17px;
  right: 100px;
  cursor: pointer;
  padding: 5px 20px;
  border: 1px solid #fff;
  line-height: 16px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  border-radius: 4px;

  i {
    margin-right: 10px;
  }
`;

export const UserLogout = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  
  & i {
    font-size: 25px;
    color: white;
    transition: color 0.3s linear;
  }

  &:hover {
    & i {
      color: #333333;
    }
  }
`;